module.exports = __webpack_public_path__ + "static/assets/6a405e19ad59b2a04e4170770d06a5df.png";